import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "search", "supplierRow"]

  open() {
    this.dialogTarget.showModal()
    this.searchTarget?.focus()
  }

  close() {
    this.dialogTarget.close()
    if (this.hasSearchTarget) this.searchTarget.value = ""
    this.filterRows("")
  }

  // Close when clicking the backdrop
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  search(event) {
    this.filterRows(event.target.value)
  }

  filterRows(query) {
    const q = query.toLowerCase().trim()
    this.supplierRowTargets.forEach(row => {
      const text = row.dataset.supplierName?.toLowerCase() ?? ""
      row.hidden = q.length > 0 && !text.includes(q)
    })
  }

  connect() {
    this.dialogTarget?.addEventListener("click", this.backdropClick.bind(this))
  }

  disconnect() {
    this.dialogTarget?.removeEventListener("click", this.backdropClick.bind(this))
  }
}
